import MicroModal from 'micromodal'
import Cookies from 'js-cookie'

/**
 * @module Admin
 * NOTE: JQuery dependency, do not import in main.js.
 */
const Admin = (() => {

  
  const manageBook = () => {
    const education_typology = document.querySelectorAll('select[name="education_typology"]')
    if (!education_typology || education_typology.length < 1) return
    education_typology.forEach((select) => {
      select.addEventListener('change', (e) => {
        console.log('change')

        e.preventDefault()

        const educationValue = select.value
        
        console.log(educationValue)
      })
    })
  }

  const manageAddVideoToCourse = () => {
    const buttons = document.querySelectorAll('.js-admin-add-video-to-course')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const videoUuid = button.getAttribute('data-video')
        const modalVideoUuid = document.getElementById('modalAddCourseVideoUuid')

        modalVideoUuid.value = videoUuid
        MicroModal.show('modalAddCourseVideo')
      })
    })
  }

  const manageAddWorkoutToBundle = () => {
    const buttons = document.querySelectorAll('.js-admin-add-workout-to-bundle')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const workoutUuid = button.getAttribute('data-workout')
        const modalWorkoutUuid = document.getElementById('modalAddBundleWorkoutUuid')

        modalWorkoutUuid.value = workoutUuid
        MicroModal.show('modalAddBundleWorkout')
      })
    })
  }

  const manageAddWorkoutToChallenge = () => {
    const buttons = document.querySelectorAll('.js-admin-add-workout-to-challenge')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const workoutUuid = button.getAttribute('data-workout')
        const modalWorkoutUuid = document.getElementById('modalAddChallengeWorkoutUuid')

        modalWorkoutUuid.value = workoutUuid
        MicroModal.show('modalAddChallengeWorkout')
      })
    })
  }

  const manageAddVideoToChallenge = () => {
    const buttons = document.querySelectorAll('.js-admin-add-video-to-challenge')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const videoUuid = button.getAttribute('data-video')
        const modalVideoUuid = document.getElementById('modalAddChallengeVideoUuid')

        modalVideoUuid.value = videoUuid
        MicroModal.show('modalAddChallengeVideo')
      })
    })
  }

  const manageAddWtaLabWorkout = () => {
    const buttons = document.querySelectorAll('.js-admin-add-wta-lab-workout')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const workoutUuid = button.getAttribute('data-workout')
        const modalWorkoutUuid = document.getElementById('modalAddWtaLabUserWorkoutUuid')

        modalWorkoutUuid.value = workoutUuid
        MicroModal.show('modalAddWtaLabUserWorkout')
      })
    })
  }

  const manageRemoveWtaLabWorkout = () => {
    const buttons = document.querySelectorAll('.js-admin-remove-wta-lab-workout')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const workoutUuid = button.getAttribute('data-workout')
        const modalWorkoutUuid = document.getElementById('modalRemoveWtaLabUserWorkoutUuid')

        modalWorkoutUuid.value = workoutUuid
        MicroModal.show('modalRemoveWtaLabUserWorkout')
      })
    })
  }

  const manageAddWtaLabVideo = () => {
    const buttons = document.querySelectorAll('.js-admin-add-wta-lab-video')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const videoUuid = button.getAttribute('data-video')
        const modalVideoUuid = document.getElementById('modalAddWtaLabUserVideoUuid')

        modalVideoUuid.value = videoUuid
        MicroModal.show('modalAddWtaLabUserVideo')
      })
    })
  }

  const manageRemoveWtaLabVideo = () => {
    const buttons = document.querySelectorAll('.js-admin-remove-wta-lab-video')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const videoUuid = button.getAttribute('data-video')
        const modalVideoUuid = document.getElementById('modalRemoveWtaLabUserVideoUuid')

        modalVideoUuid.value = videoUuid
        MicroModal.show('modalRemoveWtaLabUserVideo')
      })
    })
  }

  const manageAddFaqToCourse = () => {
    const buttons = document.querySelectorAll('.js-admin-add-faq-to-course')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const faqUuid = button.getAttribute('data-faq')
        const modalFaqUuid = document.getElementById('modalAddCourseFaqUuid')

        modalFaqUuid.value = faqUuid
        MicroModal.show('modalAddCourseFaq')
      })
    })
  }

  const manageAddCourseToTraining = () => {
    const buttons = document.querySelectorAll('.js-admin-add-course-to-training')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const courseUuid = button.getAttribute('data-course')
        const modalCourseUuid = document.getElementById('modalAddTrainingCourseUuid')

        modalCourseUuid.value = courseUuid
        MicroModal.show('modalAddTrainingCourse')
      })
    })
  }

  const manageLangSwitch = () => {
    const switches = document.querySelectorAll('.js-admin-lang-switch')
    const switchesContent = document.querySelectorAll('.js-admin-lang-switch-content')
    if (!switches || switches.length < 1) return

    // Add click listener to change lang form.
    switches.forEach((switchLang) => {
      const lang = switchLang.getAttribute('data-lang')

      switchLang.addEventListener('click', (e) => {
        e.preventDefault()

        Cookies.set('admin-lang', lang)
        switches.forEach((sl) => {
          if (sl.getAttribute('data-lang') === lang) {
            sl.classList.add('is-active')
          } else {
            sl.classList.remove('is-active')
          }
        })

        switchesContent.forEach((slc) => {
          if (slc.getAttribute('data-lang') === lang) {
            slc.classList.add('is-active')
          } else {
            slc.classList.remove('is-active')
          }
        })
      })
    })

    // Set default active lang.
    const defaultLang = Cookies.get('admin-lang')
    if (defaultLang) {
      switches.forEach((switchLang) => {
        const lang = switchLang.getAttribute('data-lang')
        if (lang === defaultLang) {
          switchLang.classList.add('is-active')
        } else {
          switchLang.classList.remove('is-active')
        }
      })
      switchesContent.forEach((switchLangContent) => {
        const lang = switchLangContent.getAttribute('data-lang')
        if (lang === defaultLang) {
          switchLangContent.classList.add('is-active')
        } else {
          switchLangContent.classList.remove('is-active')
        }
      })
    }
  }

  const manageEditUserCourse = () => {
    const buttons = document.querySelectorAll('.js-admin-edit-user-course')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const userCourseId = button.getAttribute('data-user-course-id')
        const modalUserCourseId = document.getElementById('modalEditUserCourseId')

        modalUserCourseId.value = userCourseId
        MicroModal.show('modalEditUserCourse')
      })
    })
  }

  const manageTransferUserCourse = () => {
    const buttons = document.querySelectorAll('.js-admin-transfer-user-course')
    if (!buttons || buttons.length < 1) return

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const userCourseId = button.getAttribute('data-user-course-id')
        const modalUserCourseId = document.getElementById('modalTransferUserCourseId')

        modalUserCourseId.value = userCourseId
        MicroModal.show('modalTransferUserCourse')
      })
    })
  }

  const init = () => {
    manageLangSwitch(),
    manageBook(),
    manageEditUserCourse(),
    manageTransferUserCourse()
  }

  return {
    manageAddVideoToCourse,
    manageAddWorkoutToBundle,
    manageAddWorkoutToChallenge,
    manageAddVideoToChallenge,
    manageAddWtaLabWorkout,
    manageRemoveWtaLabWorkout,
    manageAddWtaLabVideo,
    manageRemoveWtaLabVideo,
    manageAddFaqToCourse,
    manageAddCourseToTraining,
    manageEditUserCourse,
    manageTransferUserCourse,
    init
  }
})()

export default Admin



// WEBPACK FOOTER //
// app/javascript/scripts/components/Admin.js